<div class="modal-dialog" role="document">
  <div class="modal-content copia-pratica">
    <p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
      <button class="btn btn-default-reverse btn-block btn-sm" data-dismiss="modal" type="button" (click)="close()">Chiudi</button>
    </p>
    <div class="col-sm-12 coldx" *ngIf="pratica?.id">
    <h4>Copia pratica</h4>
    <ul  class="pratiche">
    <li class="panel">
    <div class="{{'pratica ' + getClassPratica(pratica.tipoPratica?.id)}}">
    <div>
      <p [className]="'categoria '+getClassPratica(pratica.tipoPratica?.id)">{{pratica.intestazione?.campi?.tipoPratica}}</p>
      <p class="codice">{{pratica.intestazione?.campi?.posizionePratica}}</p>
    </div>
    <div class="data_opzioni fasi">
      <ul>
      </ul>
    </div>
    <div>
      <p class="identificativo">
              {{(pratica.intestazione?.campi?.dataAperturaPratica ?
          (' DEL ' + (pratica.intestazione?.campi?.dataAperturaPratica |
              date:'dd/MM/yyyy')) : (pratica.intestazione?.campi?.dataApertura ?
              (' DEL ' + (pratica.intestazione?.campi?.dataApertura |  date:'dd/MM/yyyy')) : '')) + (pratica.definito ? ' DEFINITA' : '')
              + ((pratica.intestazione?.campi?.definita && pratica.intestazione?.campi?.dataDefinizione) ? ' IL ' +
              (pratica.intestazione?.campi?.dataDefinizione | date:'dd/MM/yyyy') : '')}} &nbsp;
              <span *ngIf="pratica.intestazione?.campi?.definita" title="Definita"
                class="glyphicon glyphicon-lock"></span>
              <span *ngIf="pratica.correlata" title="Correlata"
                class="glyphicon glyphicon-link"></span>
              <span *ngIf="pratica.intestazione?.campi?.capofila" title="Capofila riunione di giudizi"
                class="riunionegiudizi glyphicon glyphicon-resize-small"><span
                class="glyphicon capofila">C</span></span>
              <span *ngIf="pratica.intestazione?.campi?.riunita" title="Riunione di giudizi"
                class="glyphicon glyphicon-resize-small"></span>
              <span *ngIf="pratica.intestazione?.campi?.archiviata" title="Archiviata"
                class="glyphicon glyphicon-floppy-saved"></span>
        </p>
      <h4 class="titolo">
                {{pratica.intestazione?.campi?.contropartePrimaria ?
                pratica.intestazione?.campi?.contropartePrimaria + " - " :
                "Nessun soggetto/parte specificato " + " - " }} {{
                pratica.intestazione?.campi?.materia ?
                pratica.intestazione?.campi?.materia + "/" : ""}} {{
                pratica.intestazione?.campi?.oggetto ?
                pratica.intestazione?.campi?.oggetto : "" }}
      </h4>
    </div>
    </div>
    </li>
    </ul>
    <ul  class="pratiche firstlevel">
    <li class="panel">
        <ul class="collapse in" id="subpratica1">
          <span class="load" *ngIf="loadInit">... loading</span>
          <!--CICLO FASCICOLI-->
          <li *ngFor="let fascicolo of fascicoli; let i = index">
            <div
              class="{{'subpratica ' + (getCssClassCategoriaFascicolo(fascicolo)) + (!fascicolo.visible ? ' disabled' : '') }}">
              <div>
                <p class="{{'categoria ' + fascicolo?.tipoFascicolo?.label}}">{{fascicolo?.tipoFascicolo.label}}</p>
                <p class="codice">{{fascicolo?.posizione}}</p>
              </div>
              <div class="data_opzioni blocco_pratica">
                <div singleCheckBoxModInput [labelInput]="''"
                     [showLabel]="false" idInput="fascicolo-selected-{{i}}"
                     [objectReference]="fascicolo?.selected"
                     [submitPending]="!sezioni[fascicolo.id]"
                     (onReturn)="fascicolo.selected = $event; aggiungiFascicolo(fascicolo)"></div>
              </div>
              <div>
                <p class="identificativo">
                  {{fascicolo?.intestazione.campi.numeroRuolo ? 'N. ruolo' :''}}
                  <strong>{{fascicolo?.intestazione.campi.numeroRuolo ?	fascicolo?.intestazione.campi.numeroRuolo+' ' :''}} </strong>
                  {{fascicolo?.intestazione.campi.annoRuolo && fascicolo?.intestazione.campi.numeroRuolo ? '-' :''}}
                  {{fascicolo?.intestazione.campi.annoRuolo ? 'A. ruolo' :''}}
                  <strong>{{fascicolo?.intestazione.campi.annoRuolo ?	fascicolo?.intestazione.campi.annoRuolo+' ' :' '}} </strong>
                  {{ fascicolo?.intestazione.campi.annoRuolo || fascicolo?.intestazione.campi.numeroRuolo ? '&nbsp;' : '' }}
                  {{ 'DEL ' + (fascicolo.dataInizioFascicolo | date:'dd/MM/yyyy') }}
                   {{ fascicolo?.definito ? ' - DEFINITO IL ' +
                    (fascicolo?.dataDefinizione | date:'dd/MM/yyyy') :
                    '' }} &nbsp;
                  {{(fascicolo.intestazione.campi.tipoRicorso) ? (' - '+fascicolo.intestazione.campi.tipoRicorso) : ''}}&nbsp;
                  {{(fascicolo.intestazione.campi.tipoOpposizione) ? (' - '+fascicolo.intestazione.campi.tipoOpposizione) : ''}}
                  <span *ngIf="fascicolo?.definito" title="Definito" class="glyphicon glyphicon-lock"></span>
                  <span *ngIf="fascicolo?.capofila" title="Capofila riunione di giudizi" class="riunionegiudizi glyphicon glyphicon-resize-small"><span class="glyphicon capofila">C</span></span>
                  <span *ngIf="fascicolo?.riunito" title="Riunione di giudizi" class="glyphicon glyphicon-resize-small"></span>
                  <span *ngIf="fascicolo.intestazione.campi.isDocumentazione" class="glyphicon glyphicon-file" title="Documenti allegati"></span>
                  <a data-toggle="collapse" href="{{'#fascicolo-' + i}}"
                     (click)="loadSection(fascicolo.id, fascicolo.tipoFascicolo.endpoint)"
                     aria-expanded="false" class="collapsed tipo_fase"><span>Apri</span></a>
                </p>
                <h5 class="titolo">
                  {{fascicolo?.riassunto?.campi?.contropartePrimaria ?
                  fascicolo?.riassunto?.campi?.contropartePrimaria  : "Nessun soggetto/parte specificato" }}
                  <ng-container> {{
                    fascicolo.intestazione.campi.grado ?
                    " - " + fascicolo.intestazione.campi.grado : "" }}
                  </ng-container>
                  {{fascicolo?.intestazione.campi.natura ? " - " +
                    fascicolo?.intestazione.campi.natura : ""}}
                </h5>
              </div>
              <!--DETTAGLIO FASCICOLO CONTROPARTE -->
              <div class="togglepanel box_fase collapse" id="fascicolo-{{i}}" aria-expanded="false">
                <div class="container_dati_generali">
                  <span class="load" *ngIf="load">... loading</span>
                  <span class="load" *ngIf="!load && noControparte[fascicolo.id]">Nessuna parte</span>
                  <ng-template [ngIf]="sezioni[fascicolo.id]">
                    <ng-template [ngIf]="sezioni[fascicolo.id].controparti.length > 0">
                      <div class="row">

                        <p class="col-sm-3 ordina_data">
                          <label for="cerca-copia-prat">Cerca</label>
                          <input type="text" #searchItem id="cerca-copia-prat" (keyup)="0" class="form-control"
                                 placeholder="Inserisci nome e cognome"/>
                        </p>
                      </div>
                      <ul id="controparticollapse" class="controparti">
                        <!-- LISTA CONTROPARTI -->
                        <li class="panel">
                          <div class="controparte">
                            <div class="data_opzioni">
                              <ul class="intestazione">
                                <li>
                                  <div singleCheckBoxModInput [labelInput]="''"
                                       [showLabel]="true" [labelChecked]="'Tutti'" [labelNotChecked]="'Tutti'"
                                       idInput="controparte-selectedAll-{{i}}"
                                       [objectReference]="fascicolo?.selectedAllControparti" [labelSemibold]="true"
                                       [submitPending]="!fascicolo.selected"
                                       (onReturn)="fascicolo.selectedAllControparti = $event; aggiungiAllControparti(fascicolo)"></div>
                                </li>
                                <li>
                                  <p><strong>Primaria</strong></p>
                                </li>
                              </ul>
                            </div>
                            <div>
                              <h4 class="titolo col-sm-4"> Nominativo </h4>
                              <p class="col-sm-4"><strong> Cod. Fiscale/P. IVA </strong></p>
                              <p class="col-sm-3"><strong> Matricola </strong></p>
                            </div>
                          </div>
                        </li>
                        <ng-template ngFor
                                     let-controparte
                                     [ngForOf]="sezioni[fascicolo.id].controparti | searchFilter : searchItem.value : 'parte.nominativo'  | orderBy : 'dataAssociazione:ASC'"
                                     let-j=index>
                          <li class="panel" style="padding-top: 6px;">
                            <div class="controparte">
                              <div class="data_opzioni">
                                <ul>
                                  <li>
                                    <div singleCheckBoxModInput [labelInput]="''"
                                         [showLabel]="false" idInput="controparte-selected-{{i}}-{{j}}"
                                         [objectReference]="controparte?.selected" [submitPending]="!fascicolo.selected"
                                         (onReturn)="controparte.selected = $event; aggiungiControparte(fascicolo, controparte)"></div>
                                  </li>
                                  <li *ngIf="controparte.primario" class="star"></li>
                                  <li *ngIf="!controparte.primario" class="star-empty"
                                      style="cursor: pointer;"
                                      (click)="onSelectPrimario(controparte, fascicolo.id)"></li>
                                </ul>
                              </div>
                              <div>
                                <a [attr.data-toggle]="'collapse'" href="#subcontroparte-{{i}}-{{j}}"
                                   attr.aria-expanded="false" class="collapsed"
                                   [attr.aria-controls]="'subcontroparte-'+i+'-'+j"
                                   [attr.data-parent]="'#controparticollapse'"> <span>Apri</span>
                                </a>
                                <!-- intestazione nome e cognome o denominazione -->
                                <h4 class="titolo col-sm-4" *ngIf="controparte.parte?.nominativo">
                                  {{controparte.parte?.nominativo}}
                                </h4>
                                <h4 class="titolo col-sm-4"
                                    *ngIf="!controparte.parte?.nominativo && controparte.parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
                                  {{controparte.parte?.cognome + ' ' + controparte.parte?.nome}}
                                </h4>
                                <h4 class="titolo col-sm-4"
                                    *ngIf="!controparte.parte?.nominativo && controparte.parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
                                  {{controparte.parte?.ragioneSociale}}
                                </h4>
                                <!--<h4 class="titolo col-sm-4">{{ controparte.parte.nominativo }}</h4>-->
                                <ng-template
                                  [ngIf]="controparte.parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
                                  <p class="col-sm-4">
                                    C/F: <strong> {{ controparte.parte.codiceFiscale }} </strong>
                                  </p>
                                  <p class="col-sm-3">
                                    MAT: <strong> {{ controparte.parte.matricola }} </strong>
                                  </p>
                                </ng-template>
                                <ng-template
                                  [ngIf]="controparte.parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
                                  <p class="col-sm-4">
                                    P.IVA: <strong> {{ controparte.parte.partitaIva }} </strong>
                                  </p>
                                </ng-template>
                                <ng-template [ngIf]="controparte.ritirato">
                                  <p class="col-sm-1 status" style="width: 20px;"><span title="Rinunciatario">R</span></p>
                                </ng-template>
                              </div>
                            </div>
                            <ul class="collapse subcontroparte" id="subcontroparte-{{i}}-{{j}}">
                              <li>
                                <div class="container_tab_nav">
                                  <p>Visualizza</p>
                                  <ul class="nav nav-tabs two">
                                    <li class="active"><a data-toggle="tab"
                                                          href="#tabcontent1_{{i}}-{{j}}">Associativa</a></li>
                                    <li><a data-toggle="tab" href="#tabcontent2_{{i}}-{{j}}">Anagrafica</a></li>
                                  </ul>
                                  <!-- TAB CONTROPARTE-->
                                  <div class="tab-content">
                                    <div id="tabcontent1_{{i}}-{{j}}" class="tab-pane fade in active">
                                      <form>
                                        <div class="row">
                                          <div labelTextInput class="col-sm-3 bloccodati"
                                               [typeLabel]="'text'" [labelInput]="'Tipo soggetto'"
                                               [valueInput]="controparte.flagAttore ? 'Attore' : 'Convenuto'"></div>
                                          <!--<div labelTextInput class="col-sm-2 bloccodati"
                                               [typeLabel]="'date'" [labelInput]="'Data associazione'"
                                               [valueInput]="controparte.dataAssociazione"></div>-->
                                          <div labelTextInput class="col-sm-3 bloccodati"
                                               [typeLabel]="'text'" [labelInput]="'Categoria'"
                                               [valueInput]="controparte.categoria ? controparte.categoria?.label : ''"></div>
                                          <div labelTextInput class="col-sm-3 bloccodati"
                                               [typeLabel]="'boolean'" [labelInput]="'Rinunciatario'"
                                               [valueInput]="controparte.ritirato"></div>
                                          <div labelTextInput class="col-sm-3 bloccodati"
                                               [typeLabel]="'date'" [labelInput]="'Data rinuncia'"
                                               [valueInput]="controparte.dataTermine"></div>
                                        </div>
                                        <div class="row">
                                          <div class="col-sm-12 bloccodati">
                                            <p>
                                              <label class="col-sm-12">Note</label> <span
                                              class="longtext">{{ controparte.note }}</span>
                                            </p>
                                          </div>

                                        </div>
                                      </form>
                                    </div>
                                    <div id="tabcontent2_{{i}}-{{j}}" class="tab-pane fade">
                                      <!--<div controparte_anagrafica_view [controparte]="controparte"
                                           [hideOtherData]="true"></div>-->
                                      <app-dati-generali-anagrafiche *ngIf="isPrd" [controparte]="controparte" [isPartiSearch]="true" [hideOtherData]="true"></app-dati-generali-anagrafiche>
                                    </div>
                                  </div>
                                  <!-- FINE TAB CONTROPARTE-->
                                </div>
                              </li>
                            </ul>
                          </li>
                        </ng-template>
                        <!--FINE LISTA CONTROPARTI -->
                      </ul>
                    </ng-template>
                  </ng-template>
                </div>
              </div>
              <!-- FINE DETTAGLIO FASCICOLO CONTROPARTE -->
            </div>
          </li>
          <!-- FINE CICLO FASCICOLI-->
        </ul>
      </li>
      </ul>
      <form #form="ngForm" (ngSubmit)="copiaPratica();">
        <div class="row">
          <div datePickerInput class="col-sm-12" [labelInput]="'Data apertura'"	[mandatory]="true" required
          [(ngModel)]="dataInizioPratica" [ngModelOptions]="{standalone: true}"></div>
        </div>
        <div class="row">
          <p class="col-sm-12 mandatory"><em>* Campi obbligatori</em></p>
        </div>
        <div class="row">
          <div class="col-xs-6 visible-xs"></div>
          <p submitButton [submitPending]="disabledSubmit() || submitPending" class="col-sm-3 col-xs-6 col-sm-offset-9" [labelButton]="'Copia e inserisci'">
        </div>
      </form>

    </div>
  </div>
</div>
